import {DisplayMinute} from "../../directives/display.minute";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

import {Utils} from "../../model/Utils";
import {MealDurationType} from "../../model/MealDurationType";

export class ExplainMeal{

  constructor(
              private domSanitizer: DomSanitizer,
              private translate: TranslateService) {
    }


  public explainMeal( durationType: MealDurationType, normalMealDurationInMinutes: number, scheduledMealDurationInMinutes: number,
                      mealIsPaid: boolean, currentMealDuration: number, startPunch: Date, endPunch: Date):SafeHtml{
    let res = '';
    let defaultDuration = scheduledMealDurationInMinutes;
    if (defaultDuration<=0){
      defaultDuration = normalMealDurationInMinutes;
    }


    if (mealIsPaid){
      this._debug('Meal is Paid');
      const displayMinute = new DisplayMinute();
      if (currentMealDuration > defaultDuration){
        let toRemove = 0;
        if (!Utils.isNullOrUndefined(startPunch) && !Utils.isNullOrUndefined(endPunch)){
          toRemove = Utils.diffDateInMinutes(startPunch,endPunch);
        }
        res = this.translate.instant('MealIsPaidBut',{normalDuration: displayMinute.transform(defaultDuration),
                                                                           currentDuration:displayMinute.transform(currentMealDuration),
                                                                        shouldNotBePaid:  displayMinute.transform(currentMealDuration - defaultDuration),
                                                                        willNotBePaid: displayMinute.transform(toRemove)});
        this._debug('0: ' +  res);
      }else{
        this._debug('0+: ' +  res);
        let toRemove = 0;
        if (!Utils.isNullOrUndefined(startPunch) && !Utils.isNullOrUndefined(endPunch)){
          toRemove = Utils.diffDateInMinutes(startPunch,endPunch);
        }
        if (toRemove>0){
          res = this.translate.instant('MealIsPaidButNotSome',{willNotBePaid: displayMinute.transform(toRemove)});
        }else{
          res = this.translate.instant('MealIsPaid');
        }
      }


    }else{
      const displayMinute = new DisplayMinute();
      this._debug('DurationType ' + durationType);
      if (MealDurationType.DEFAULT_DURATION === durationType){
        this._debug('Using Default Duration ' + defaultDuration + ' min.');
        if (!Utils.isNullOrUndefined(startPunch) && !Utils.isNullOrUndefined(endPunch)){
          const toRemove = Utils.diffDateInMinutes(startPunch,endPunch);
          res = this.translate.instant('MealIsNotPaidDefaultDuration',{shouldNotBePaid:  displayMinute.transform(defaultDuration), willNotBePaid: displayMinute.transform(toRemove)});
          this._debug('1: ' +  res);
        }else{
          res = this.translate.instant('MealIsNotPaidDefaultDuration',{shouldNotBePaid:  displayMinute.transform(defaultDuration), willNotBePaid: displayMinute.transform(0)});
          this._debug('2: ' +  res);
        }
      }else{
        /*
        if (MealDurationType.PUNCH_DURATION_WITH_MIN === durationType) {
          console.log('Punch Duration ' + currentMealDuration + ' min: ' + defaultDuration);
          if (Utils.isNullOrUndefined(currentMealDuration) || (currentMealDuration < defaultDuration)) {
            currentMealDuration = defaultDuration;
          }
        }
        */
        this._debug('Punch Duration ' + currentMealDuration);
        if (!Utils.isNullOrUndefined(startPunch) && !Utils.isNullOrUndefined(endPunch)){
          const toRemove = Utils.diffDateInMinutes(startPunch,endPunch);
          res = this.translate.instant('MealIsNotPaidPunchDuration',{shouldNotBePaid:  displayMinute.transform(currentMealDuration), willNotBePaid: displayMinute.transform(toRemove)});
          this._debug('5: ' +  res);
        }else{
          res = this.translate.instant('MealIsNotPaidPunchDuration',{shouldNotBePaid:  displayMinute.transform(currentMealDuration), willNotBePaid: displayMinute.transform(0)});
         this._debug('6: ' +  res);
        }
      }
    }
    return this.domSanitizer.bypassSecurityTrustHtml(res);
  }

  private _debug(data: string){
    // console.log(data);
  }

}
